import { render, staticRenderFns } from "./InitialIssuanceDocumentDropoffForm.vue?vue&type=template&id=01c43f6c"
import script from "./InitialIssuanceDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./InitialIssuanceDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports